<div class="blob-background">
	<div class="blob one"></div>
	<div class="blob two"></div>
	<div class="blob three"></div>
	<div class="blob four"></div>
	<div class="blob five"></div>
	<div class="middle">
		<form>
			@if (!success) {
			<div class="floating-panel">
				<div class="branded-asset-logo"></div>
				<hr>
				<div [hidden]="showMfa" class="mb-3 narrow">
					<label for="password">Password</label>
					<input [(ngModel)]="password" id="password" name="password" type="password" autocomplete="current-password" placeholder="Password" class="form-control">
				</div>
				<div [hidden]="showMfa" class="mb-3 narrow">
					<label for="password2">Confirm Password</label>
					<input [(ngModel)]="password2" id="password2" name="password2" type="password" autocomplete="current-password" placeholder="Password" class="form-control">
				</div>
				@if (showMfa) {
				<div class="mb-3 narrow">
					<label for="mfa">MFA Code</label>
					<input [(ngModel)]="mfaCode" id="mfa" name="mfa_code" type="text" autocomplete="one-time-code" placeholder="6 Digit Code" class="form-control">
				</div>
				}
				<div class="button-group narrow mt-3">
					<app-action-button submit #resetButton [action]="Reset" [context]="this" btnClass="full-green wider" [disabled]="!password || !password2 || (showMfa && !mfaCode)"
						processing="Resetting...">Reset Password</app-action-button>
					@if (showMfa) {
					<button type="button" class="button ms-3" (click)="CancelMfa()">Cancel</button>
					}
				</div>
				@if (!showMfa) {
				<div class="narrow">
					<a [routerLink]="['/login']">Return to login</a>
				</div>
				}
			</div>
			}
			@if (success) {
			<div class="floating-panel">
				<div class="branded-asset-logo"></div>
				<hr>
				<div>
					Your password has been successfully reset. You may now <a [routerLink]="['/login']">log in</a> with your new password.
				</div>
			</div>
			}
		</form>
	</div>
</div>